import React, {
    useCallback,
    useMemo,
    useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import {
    ClientSideRowModelModule,
    ModuleRegistry,
    NumberEditorModule,
    TextEditorModule,
    ValidationModule,
} from "ag-grid-community";
import { useDispatch, useSelector } from 'react-redux';
ModuleRegistry.registerModules([
    NumberEditorModule,
    TextEditorModule,
    ClientSideRowModelModule,
    ValidationModule /* Development Only */,
]);


let rowImmutableStore;

const GridExample = (props) => {
    const dispatch = useDispatch()
    const selectAuthToken = state => state.apiKey
    const selectStore = state => state
    const authToken = useSelector(selectAuthToken);
    const reduxData = useSelector(selectStore);
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
    const [rowData, setRowData] = useState([]);
    const [fetchFoundData, setFetchFoundData] = useState([])
    const [fetchMetadata, setFetchMetadata] = useState([])
    const [columnDefs, setColumnDefs] = useState()
    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 100,
            editable: true,
        };
    }, []);
    const getRowId = useCallback((params) => String(params.data.id), []);

    const onGridReady = useCallback((params) => {
       
            let toSend = {
                userLevel: reduxData.userInfo.level.pk,
                query: props.queryToRun
            }
            dispatch({ type: 'foundation/setFetchTime' })
            let bearerVAR = "Bearer " + authToken
            fetch('FindData', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                .then((response) => response.json())
                .then((responseJSON) => { 
                    setFetchFoundData(JSON.parse(responseJSON[0]))
                    setFetchMetadata(JSON.parse(responseJSON[1]))
                    let addIndex = JSON.parse(responseJSON[0]);
                    addIndex.forEach((item, index) => (item.id = index));
                    rowImmutableStore = addIndex;
                    setRowData(rowImmutableStore);
                    let cols = []
                    let keys = Object.getOwnPropertyNames(JSON.parse(responseJSON[0])[0])
                    keys = keys.filter((val) => val != "id" && val != "Id" && val != "PK")
                    for (var key of keys) {
                        if (key != "Metadata") {
                            let item = {
                                field: key,
                                editable: true
                            }
                            cols.push(item)
                        }
                    }
                    setColumnDefs(cols)
               })
        
    }, []);

    const onCellEditRequest = useCallback(
        (event) => {
            let findMetadata = fetchMetadata[0][event.colDef.field]
            const data = event.data;
            const field = event.colDef.field;
            const newValue = event.newValue;
            const oldItem = rowImmutableStore.find((row) => row.id === data.id);
            //const pkProcessed = oldItem.PK
            let toSend = {
                userLevel: reduxData.userInfo.level.pk,
                querySignifier: findMetadata,
                pkValue: String(oldItem.PK),
                oldValue: String(oldItem[field]),
                newValue: String(event.newValue)
            }
            dispatch({ type: 'foundation/setFetchTime' })
            let bearerVAR = "Bearer " + authToken
            var answer;
            //console.log("findMetadata: ", findMetadata)
            //console.log("toSend: ", toSend)
            if (toSend.querySignifier.length > 1) {
                fetch('EditTableField', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                    .then((responseA) =>
                        responseA.json()
                    )
                    .then((responseA_JSON) => {
                        if (responseA_JSON.message == "passed") {
                            if (!oldItem || !field) {
                                return;
                            }
                            const newItem = { ...oldItem };
                            newItem[field] = newValue;
                            rowImmutableStore = rowImmutableStore.map((oldItem) =>
                                oldItem.id == newItem.id ? newItem : oldItem,
                            );
                            setRowData(rowImmutableStore);
                        }
                        else {
                            alert("The update function failed. " + responseA_JSON.message)
                        }
                        let toSend = {
                            userLevel: reduxData.userInfo.level.pk,
                            query: props.queryToRun
                        }
                        props.rerenderCallback();
                        dispatch({ type: 'foundation/setFetchTime' })
                        let bearerVAR = "Bearer " + authToken
                        fetch('FindData', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                            .then((response) => response.json())
                            .then((responseJSON) => {
                                setFetchFoundData(JSON.parse(responseJSON[0]))
                                setFetchMetadata(JSON.parse(responseJSON[1]))
                                let addIndex = JSON.parse(responseJSON[0]);
                                addIndex.forEach((item, index) => (item.id = index));
                                rowImmutableStore = addIndex;
                                setRowData(rowImmutableStore);
                                let cols = []
                                let keys = Object.getOwnPropertyNames(JSON.parse(responseJSON[0])[0])
                                keys = keys.filter((val) => val != "id" && val != "Id" && val != "PK")
                                for (var key of keys) {
                                    if (key != "Metadata") {
                                        let item = {
                                            field: key,
                                            editable: true
                                        }
                                        cols.push(item)
                                    }
                                }
                                setColumnDefs(cols)
                            })
                    })
            }
            else {
                alert("This field does not support editing.")
            }
        },
        [rowImmutableStore],
    );

    return (
         <div style={containerStyle}>
            {<div style={gridStyle}>
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    getRowId={getRowId}
                    readOnlyEdit={true}
                    onGridReady={onGridReady}
                    onCellEditRequest={onCellEditRequest}
                />
            </div>}
        </div>
    );
};

export default GridExample;